import toast from "@/utils/toast";

export default {
  success: {
    createCall: () => {
      toast({
        type: "success",
        title: "İşlem Başarılı",
        content: "Çağrı planlama işlemi başarıyla gerçekleşmiştir.",
      });
    },
    updateCall: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Çağrı başarıyla güncellendi",
      });
    },
    createBank: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kasa başarıyla oluşturuldu.",
      });
    },
    createExpense: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Gider kalemi başarıyla oluşturuldu.",
      });
    },
    createRevenue: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Gelir kalemi başarıyla oluşturuldu.",
      });
    },
    payInvoice: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Fatura başarıyla ödenmiştir.",
      });
    },
    createProperty: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Mağaza başarıyla oluşturuldu.",
      });
    },
    createStore: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Depo başarıyla oluşturuldu.",
      });
    },
    addTenantRent: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kira başarıyla eklendi.",
      });
    },
    addSubExpense: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Alt gider kalemi başarıyla eklendi.",
      });
    },
    addExpenseAmount: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Gider kalemi tutarı başarıyla eklendi.",
      });
    },
    addRevenueAmount: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Gelir kalemi tutarı başarıyla eklendi.",
      });
    },
    deleteSubExpense: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Alt gider kalemi başarıyla silindi.",
      });
    },
    deleteSubExpenseInvoice: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Fatura başarıyla silindi.",
      });
    },
    updateSubExpense: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Alt gider kalemi başarıyla güncellendi.",
      });
    },
    updateExpense: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Gider kalemi başarıyla güncellendi.",
      });
    },
    updateRevenue: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Gelir kalemi başarıyla güncellendi.",
      });
    },
    updateActivity: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "İşlem başarıyla güncellendi.",
      });
    },
    updateTenant: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Bilgiler başarıyla güncellendi.",
      });
    },
    addInvoice: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Fatura başarıyla işlendi.",
      });
    },
    addTenantSubscription: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Aidat başarıyla eklendi.",
      });
    },
    addTenant: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kiracı başarıyla eklendi.",
      });
    },
    deleteBank: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kasa silme işlemi başarıyla gerçekleştirildi.",
      });
    },
    transfer: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Bakiye başarıyla transfer edilmiştir.",
      });
    },
    initialTransfer: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Tutar başarıyla transfer edilmiştir.",
      });
    },
    updateBank: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kasa bilgileri başarıyla güncellendi.",
      });
    },
    revertActivity: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "İşlem başarıyla silinmiştir.",
      });
    },
    deleteProperty: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Mağaza silme işlemi başarıyla gerçekleştirildi.",
      });
    },
    deleteStore: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Depo silme işlemi başarıyla gerçekleştirildi.",
      });
    },
    deleteTenant: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kişi silme işlemi başarıyla gerçekleştirildi.",
      });
    },
    deleteTenantRent: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kira silme işlemi başarıyla gerçekleştirildi.",
      });
    },
    deleteExpense: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Gider kalemi silme işlemi başarıyla gerçekleştirildi.",
      });
    },
    deleteRevenue: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Gelir kalemi silme işlemi başarıyla gerçekleştirildi.",
      });
    },
    removeTenant: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kiracı başarıyla mağazadan çıkartılmıştır.",
      });
    },
    removeTenantStore: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kiracı başarıyla depodan çıkartılmıştır.",
      });
    },
    changePassword: () => {
      toast({
        title: "İşlem başarılı",
        type: "success",
        content: "Şifreniz başarıyla güncellenmiştir",
      });
    },
    updateLogo: () => {
      toast({
        title: "İşlem başarılı",
        type: "success",
        content: "Logonuz başarıyla güncellenmiştir.",
      });
    },
    updateCertificate: () => {
      toast({
        title: "İşlem başarılı",
        type: "success",
        content: "Sertifika bilgileriniz başarıyla güncellenmiştir.",
      });
    },
    passwordCreated: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Şifreniz başarıyla oluşturuldu",
      });
    },
    createUser: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kullanıcı eklendi ve şifre oluşturma maili gönderildi",
      });
    },
    deleteUser: () => {
      toast({
        type: "success",
        title: "İşlem başarılı",
        content: "Kullanıcı başarılı bir şekilde silindi.",
      });
    },
  },
  error: {
    generalFillError: (message?: string) => {
      toast({
        title: "İşlem başarısız",
        content: message || "Girilen değerleri kontrol ederek tekrar deneyiniz",
      });
    },
    generalError: (message?: string) => {
      toast({
        title: "Hata meydana geldi",
        content: message || "İşlemininizi şu an gerçekleştiremiyoruz",
      });
    },
    createCall: () => {
      toast({
        title: "İşlem Başarısız",
        content:
          "Girdiğiniz değerleri kontrol ederek daha sonra tekrar deneyiniz.",
      });
    },
    createBank: () => {
      toast({
        title: "İşlem Başarısız",
        content:
          "Girdiğiniz değerleri kontrol ederek daha sonra tekrar deneyiniz.",
      });
    },
    createProperty: (message?: string) => {
      toast({
        title: "İşlem Başarısız",
        content: message,
      });
    },
    addTenantRent: (message?: string) => {
      toast({
        title: "İşlem Başarısız",
        content: message,
      });
    },
    addTenant: (message?: string) => {
      toast({
        title: "İşlem Başarısız",
        content: message,
      });
    },
    transfer: (message?: string) => {
      toast({
        title: "Hata meydana geldi",
        content: message,
      });
    },
    deleteProperty: (message?: string) => {
      toast({
        title: "Hata meydana geldi",
        content: message || "Id boş olamaz",
      });
    },
    changePassword: (message?: string) => {
      toast({
        title: "İşlem başarısız",
        content: message || "Girilen değerleri kontrol ederek tekrar deneyiniz",
      });
    },
    updateLogo: () => {
      toast({
        title: "İşlem başarısız",
        content: "Girilen değerleri kontrol ederek tekrar deneyiniz.",
      });
    },
  },
  warning: {
    passwordNotMatched: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content: "Girmiş olduğunuz yeni şifreler eşleşmelidir",
      });
    },
    fillWarning: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content: "Lütfen bütün alanları doldurunuz",
      });
    },
    emailValidation: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content: "Lütfen mail adresinizi giriniz",
      });
    },
    resetPassword: (message?: string) => {
      toast({ title: "Hata", content: message });
    },
    deleteSelf: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content: "Kendi kullanıcı silemezsiniz",
      });
    },
    transferAmount: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content:
          "Transfer yapabilmek için toplam bakiyenin 0'dan büyük olması gerekmektedir.",
      });
    },
    hasDebt: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content: "Kiracının mevcut borcu varken tahliye işlemi yapılamaz.",
      });
    },
    hasTenant: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content: "Kiracı mevcutken mağaza silinemez.",
      });
    },
    hasTenantStore: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content: "Kiracı mevcutken depo silinemez.",
      });
    },
    deleteBank: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content:
          "Kasa bakiyesi 0'dan farklıdır. Silme işleminden önce başka bir kasaya transfer yapmanız gerekmektedir.",
      });
    },
    download: () => {
      toast({
        type: "warning",
        title: "Uyarı",
        content: "İndirilecek bir kayıt bulunamadı.",
      });
    },
  },
};
